<template>
    <div>
        <v-checkbox color="primary" v-model="direct" required label="Navadna pošta" @change="$emit('update:direct', direct);" />
        <v-checkbox color="primary" v-model="email" required label="Elektronska pošta" @change="$emit('update:email', email);" />
        <v-checkbox color="primary" v-model="sms" required label="SMS/MMS obvestila" @change="$emit('update:sms', sms);" />
        <v-checkbox color="primary" v-model="call" required label="Telefonski klici" @change="$emit('update:call', call);" />
        <v-checkbox color="primary" v-model="digital" required label="v digitalnem okolju (splet, družbena omrežja, elektronske naprave v Tuš poslovalnicah, mobilna aplikacija Tuš)" @change="$emit('update:digital', digital);" />
        <v-checkbox color="primary" v-model="push" required label="po meri oblikovano spletno oglaševanje" @change="$emit('update:push', push);" />
    </div>
</template>

<script>
    export default {
        name: "ProfileConsentsChannels",
        props: {
            direct: {
                type: Boolean,
                default: false
            },
            email: {
                type: Boolean,
                default: false
            },
            sms: {
                type: Boolean,
                default: false
            },
            call: {
                type: Boolean,
                default: false
            },
            digital: {
                type: Boolean,
                default: false
            },
            push: {
                type: Boolean,
                default: false
            },
        }
    }
</script>

<style scoped>

</style>